/* Added by Jhamman Lal Sahu on 08-08-2024
  Reason - to render UI for Events*/

import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseURL } from "../../Api/config";
import { events } from "../../Api/services";
import { GlobalContext } from "../../context/Context";
import { default as eventStyles, default as Style } from "./Events.module.css";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const Events = () => {
  const [pastEventsDetails, setPastEventsDetails] = useState([]);
  const [upcomingEventsDetails, setUpcomingEventsDetails] = useState([]);
  const [bannerImageAndDescription, setBannerImageAndDescription] = useState(
    {}
  );
  const [selectedEvent, setSelectedEvent] = useState(null);
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const navigate = useNavigate();
  const fetchEventsDetails = async () => {
    try {
      const response = await events();
      setPastEventsDetails(response?.past_events_details);
      setUpcomingEventsDetails(response?.upcoming_events_details);
      setBannerImageAndDescription(response?.banner_image_and_description);
    } catch (error) {
      console.error("Error fetching events details:", error);
    }
  };

  useEffect(() => {
    // window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Events", path: "/events" },
    ]);

    fetchEventsDetails();
  }, []);

  const truncateTitle = (title) => {
    const words = title?.split("");
    if (words?.length > 26) {
      return words.slice(0, 26).join("") + ".......";
    }
    return title;
  };

  {
    /* Added by Yogen on 06/06/2025 
      Reason To have Condition for upcoming description length  */
  }
  const truncateSmallDescription = (description) => {
    const characters = description?.split("");
    if (windowWidth > 720 && characters?.length > 396) {
      return characters.slice(0, 150).join("") + ".";
    }
    if (windowWidth <= 720 && characters?.length > 50) {
      return characters.slice(0, 110).join("") + "...";
    }
    return description;
  };
  {
    /* End of code Addition by Yogen on 06/06/2025 
      Reason To have Condition for upcoming description length  */
  }
  const truncateDescription = (description) => {
    const characters = description?.split("");
    if (windowWidth > 720 && characters?.length > 396) {
      return characters.slice(0, 380).join("") + "......";
    }
    if (windowWidth <= 720 && characters?.length > 110) {
      return characters.slice(0, 110).join("") + "......";
    }
    return description;
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    truncateTitle();
    truncateDescription();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  if (
    pastEventsDetails &&
    upcomingEventsDetails?.pastEventsDetails?.length === 0 &&
    upcomingEventsDetails?.length === 0
  )
    return (
      <div className={Style.noDetails}>
        <p className={Style.noDetailText}>No content available</p>
      </div>
    );
  // Added By: Yogen on 16-06-2025
  // Reason - To accurately check if CKEditor content is truly empty
  function isEditorContentEmpty(htmlString) {
    const div = document.createElement("div");
    div.innerHTML = htmlString;
    const text = div.textContent || div.innerText || "";
    return text.trim().length === 0;
  }
  // End of code - Yogen on 16-06-2025
  // Reason - To accurately check if CKEditor content is truly empty
  return (
    <>
      <div className={Style.mainContainer}>
        {/* <NavigationPath navigationPathArray={navigationPath} /> */}
        {/* <div className={`${Style.pageTitle}`}>Upcoming Events</div> */}

        {/* Added by Yogen on 05/06/2025 
          Reason To have description of events  */}

        {/* <div className={eventStyles.wrapper}> */}

        {/* Added By - Yogen on 20-06-2025 
        Reason - to add for show the event banner image  */}
        {bannerImageAndDescription?.length > 0 ||
        upcomingEventsDetails?.length > 0 ? (
          <div
            className={eventStyles.wrapper}
            style={{
              backgroundImage:
                bannerImageAndDescription?.length > 0 &&
                bannerImageAndDescription[0]?.banner_image
                  ? `url(${
                      baseURL + bannerImageAndDescription[0].banner_image
                    })`
                  : "none",
            }}
          >
            <div className={`${eventStyles.navContainer}`}>
              <NavigationPath navigationPathArray={navigationPath} />
            </div>

            {/* End of code Addition by Yogen on 20/06/2025 
        Reason - to add for show the event banner image  */}

            {/* <div className={eventStyles.headerBar}>
        <h2>Notice/Announcement</h2>
      </div> */}

            {/* <div className={eventStyles.MainContainer}>
            <h4 className={eventStyles.header}>Description</h4>

            <div className={eventStyles.noticeBox}>
             <li>
                  <p>
                    Description or images data coming from backend .”In this new
                    year we are beginning our calendar events with another
                    social service programme done on 02/01/2024.Raipur Nair
                    Samajam organised the blood donation camp on the occasion of
                    Mannum Jayanthi 2024 in collaboration with AIIMS Raipur at
                    Shankara senior secondary school.Raipur Nair
                    Samajam organised the blood donation camp on the occasion of
                    Mannum Jayanthi 2024 in collaboration with AIIMS Raipur at
                    Shankara senior secondary school.
                  </p>
                </li>
            </div>
          </div> */}
            {/* Commented By - Yogen on 02-07-2025 
        Reason - to add for show the event banner image  */}
            {/* Added By - Yogen on 20-06-2025
        Reason - to remove the description section  */}
            {/* {bannerImageAndDescription?.length > 0 && ( */}
            {/* {bannerImageAndDescription[0]?.description &&
            !isEditorContentEmpty(bannerImageAndDescription[0]?.description) ? ( */}
            {/* // {bannerImageAndDescription[0]?.description?.length > 0 && (
              <div className={eventStyles.leftDescriptionContainer}>
                <h4 className={eventStyles.header}>Description</h4>
                <div className={eventStyles.descriptionBox}>
                  <p>
                    {bannerImageAndDescription[0]?.description &&
                      parse(bannerImageAndDescription[0].description)}
                  </p>
                </div>
              </div>
            ) : null} */}
            {/* } */}
            {/* End of code Addition by Yogen on 20/06/2025 
    Reason - To show the Event home Description */}
            {/* Ended By - Yogen on 02-07-2025 
        Reason - to remove the description section  */}

            {/* End of code Addition by Yogen on 05/06/2025 
           Reason To have description of the events  */}
            {/* <div className={Style.pageTitle}>Upcoming Events</div> */}
            {/* Added by Yogen on 05/06/2025 
          Reason To have Upcoming events scroller  */}
            {upcomingEventsDetails?.length > 0 && (
              <div className={eventStyles.rightUpComingEventsContainer}>
                <h4 className={eventStyles.header}>Upcoming Events</h4>

                <div className={eventStyles.noticeBox}>
                  <ul>
                    {upcomingEventsDetails?.map((data, index) => (
                      <li key={index}>
                        <p>
                          <h3>
                            {data?.title && parse(truncateTitle(data.title))}
                          </h3>
                          {/* <Link to="/event" state={data.id}> */}
                          {/* Added By - Yogen on 14/06/2025
                          Reason : to Navigate Event type */}
                          <Link
                            to="/event"
                            state={{
                              id: data.id,
                              eventType: "Upcoming Events",
                            }}
                          >
                            {/* Ended By - Yogen on 14/06/2025
                          Reason : to Navigate Event type  */}
                            {data?.description &&
                              parse(truncateSmallDescription(data.description))}
                            <small> Know More...</small>
                          </Link>
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ) : (
          <NavigationPath navigationPathArray={navigationPath} />
        )}
        {/* End of code Addition by Yogen on 05/06/2025 
           Reason To have Upcoming events scroller */}
        {pastEventsDetails?.length > 0 && (
          <div className={Style.subContainer}>
            <h4 className={eventStyles.header}>Events</h4>
            <div className={Style.imageAndtitleAndDescriptionContainer}>
              {pastEventsDetails?.map((data, index) => (
                <div
                  className={`${
                    selectedEvent && data.id === selectedEvent.id
                      ? Style.highlightedCard
                      : Style.cards
                  }`}
                  key={index}
                >
                  <div className={Style.imageField}>
                    {data.event_image ? (
                      <img
                        src={baseURL + data.event_image}
                        className={Style.all_cards_image}
                      />
                    ) : null}
                  </div>

                  <div className={Style.all_cards_title}>
                    {data?.title && parse(truncateTitle(data.title))}
                  </div>

                  <div className={Style.all_cards_description}>
                    {data?.description &&
                      parse(truncateDescription(data.description))}
                  </div>
                  <div className={Style.viewField}>
                    <button
                      className={`${Style.viewButton} ${
                        selectedEvent && data.id === selectedEvent.id
                          ? Style.highlightedViewButton
                          : ""
                      }`}
                      onClick={() => {
                        // navigate("/event", { state: data.id });
                        // Added By - Yogen on 14/06/2025
                        // Reason : to Navigate Event type
                        navigate("/event", {
                          state: { id: data.id, eventType: "Events" },
                        });
                        // Ended By - Yogen on 14/06/2025
                        // Reason : to Navigate Event type
                      }}
                    >
                      <div
                        className={`${
                          selectedEvent && data.id === selectedEvent.id
                            ? Style.highlightedViewText
                            : Style.viewText
                        }`}
                      >
                        View More
                      </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Events;

/* End of the addition by Jhamman Lal Sahu on 08-08-2024
    Reason - to render UI for Events*/
